// @flow
import React, { Component } from 'react';

import './PatternTile.css';


export default class PatternTile extends Component {

    constructor(props) {
        super(props);
        this.showDetail = this.showDetail.bind(this);

    }


    showDetail () {
        let patternDetailUri = (
            `/patterns/?id=${this.props.pattern.id}&mid=null`);

        this.props.history.push(patternDetailUri);
    }


    render () {

        let title, description;

        if (this.props.pattern.title_pl) {
            title = (
                <h2>
                    {this.props.pattern.title_pl}
                </h2>);
        }

        if (this.props.pattern.description_pl) {
            description = (
                <p>
                    {this.props.pattern.description_pl}
                </p>);

        }

        return (
            <div
                className="col s12 m6 l4 ln-tile">
                <div
                    className="ln-tile-container">

                    <img
                        src={ this.props.pattern.image_thumbnail_uri }
                        alt={ this.props.pattern.title_pl } />

                    <div
                        className="ln-overlay"
                        onClick={ this.showDetail }>

                        <div
                            className="ln-overlay-inner">
                            <div
                                className="ln-overlay-info">
                                { title }
                                { description }
                                <span
                                    className="ln-overlay-action-info">
                                    kliknij, żeby zobaczyć więcej
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)
    }
}



// WEBPACK FOOTER //
// ./src/components/PatternTile/PatternTile.js